import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { useDeviceConfigurationCache } from '../configuration/useDeviceConfigurationCache';
import { getPersonalListType } from '../configuration/utils';
import { createMissingInitRhinoError } from '../errors';
import { queryKeys } from '../queryKeys';

import { createMissingPersonalListTypeError } from './errors';
import { fetchPersonalLineup } from './queryFunctions';

export function usePersonalLineup() {
  const { configuration } = useDeviceConfigurationCache();

  const listType = configuration ? getPersonalListType(configuration) : undefined;

  const { data, error, isLoading } = useQuery({
    queryKey: listType ? queryKeys.personalLineup : queryKeys.disabled,
    queryFn: () => fetchPersonalLineup({ listType: listType! }),
    enabled: Boolean(listType),
    // TODO: replace with the value from OPC in the following PR
    staleTime: Infinity,
  });

  const configurationError = useMemo(() => {
    if (!configuration) {
      return createMissingInitRhinoError();
    }

    if (!listType) {
      return createMissingPersonalListTypeError();
    }
  }, [configuration, listType]);

  return {
    allLineups: data?.allLineups,
    error: configurationError ?? error,
    isLoading,
    personalLineup: data?.personalLineup,
  };
}
